import { createSlice } from "@reduxjs/toolkit";
import {
  forcastOverview,
  youtubeSubscribe,
  SocialTrafficMetrics,
  twitterOverview,
  instagramOverview,
  linkdinOverview,
  cashFlow,
  income,
  performance,
  trafficChanel,
  device,
  region,
  generated,
  topSale,
  location,
  closedDeals,
  recentDeal,
} from "../../demoData/dashboardChartContent.json";

export const chartSlice = createSlice({
  name: "chart",
  initialState: {
    forcastData: null,
    foLoading: false,
    youtubeSubscribeData: null,
    yuLoading: false,
    closeDealData: null,
    cdLoading: false,
    recentDealData: null,
    recLoading: false,
    socialTrafficData: null,
    soLoading: false,
    twitterOverviewData: null,
    twLoading: false,
    instagramOverviewData: null,
    inLoading: false,
    linkdinOverviewData: null,
    liLoading: false,
    cashFlowData: null,
    cfLoading: false,
    incomeData: null,
    icLoading: false,
    performanceData: null,
    perLoading: false,
    trafficChanelData: null,
    tcLoading: false,
    deviceData: null,
    dvLoading: false,
    landingPageData: null,
    lpLoading: false,
    regionData: null,
    reLoading: false,
    generatedData: null,
    geLoading: false,
    topSaleData: null,
    tsLoading: false,
    locationData: null,
    loLoading: false,
    error: null,
  },
  reducers: {
    locationBegin: (state, action) => {
      state.loLoading = true;
    },

    locationSuccess: (state, action) => {
      state.locationData = action.payload;
      state.loLoading = false;
    },

    locationErr: (state, action) => {
      state.error = action.payload;
      state.loLoading = false;
    },

    topSaleBegin: (state, action) => {
      state.tsLoading = true;
    },

    topSaleSuccess: (state, action) => {
      state.topSaleData = action.payload;
      state.tsLoading = false;
    },

    topSaleErr: (state, action) => {
      state.error = action.payload;
      state.tsLoading = false;
    },

    generatedBegin: (state, action) => {
      state.geLoading = true;
    },

    generatedSuccess: (state, action) => {
      state.generatedData = action.payload;
      state.geLoading = false;
    },

    generatedErr: (state, action) => {
      state.error = action.payload;
      state.geLoading = false;
    },

    regionBegin: (state, action) => {
      state.reLoading = true;
    },

    regionSuccess: (state, action) => {
      state.regionData = action.payload;
      state.reLoading = false;
    },

    regionErr: (state, action) => {
      state.error = action.payload;
      state.reLoading = false;
    },

    deviceBegin: (state, action) => {
      state.dvLoading = true;
    },

    deviceSuccess: (state, action) => {
      state.deviceData = action.payload;
      state.dvLoading = false;
    },

    deviceErr: (state, action) => {
      state.error = action.payload;
      state.dvLoading = false;
    },

    landingPageBegin: (state, action) => {
      state.lpLoading = true;
    },

    landingPageSuccess: (state, action) => {
      state.landingPageData = action.payload;
      state.lpLoading = false;
    },

    landingPageErr: (state, action) => {
      state.error = action.payload;
      state.lpLoading = false;
    },

    trafficChanelBegin: (state, action) => {
      state.tcLoading = true;
    },

    trafficChanelSuccess: (state, action) => {
      state.trafficChanelData = action.payload;
      state.tcLoading = false;
    },

    trafficChanelErr: (state, action) => {
      state.error = action.payload;
      state.tcLoading = false;
    },

    updateLoadingBegin: (state, action) => {
      state.perLoading = true;
    },

    updateLoadingSuccess: (state, action) => {
      state.perLoading = false;
    },

    updateLoadingErr: (state, action) => {
      state.error = action.payload;
      state.perLoading = false;
    },

    performanceBegin: (state, action) => {
      state.perLoading = true;
    },

    performanceSuccess: (state, action) => {
      state.performanceData = action.payload;
      state.perLoading = false;
    },

    performanceErr: (state, action) => {
      state.error = action.payload;
      state.perLoading = false;
    },

    incomeBegin: (state, action) => {
      state.icLoading = true;
    },

    incomeSuccess: (state, action) => {
      state.incomeData = action.payload;
      state.icLoading = false;
    },

    incomeErr: (state, action) => {
      state.error = action.payload;
      state.icLoading = false;
    },

    cashFlowBegin: (state, action) => {
      state.cfLoading = true;
    },

    cashFlowSuccess: (state, action) => {
      state.cashFlowData = action.payload;
      state.cfLoading = false;
    },

    cashFlowErr: (state, action) => {
      state.error = action.payload;
      state.cfLoading = false;
    },

    instagramOverviewBegin: (state, action) => {
      state.inLoading = true;
    },

    instagramOverviewSuccess: (state, action) => {
      state.instagramOverviewData = action.payload;
      state.inLoading = false;
    },

    instagramOverviewErr: (state, action) => {
      state.error = action.payload;
      state.inLoading = false;
    },

    linkdinOverviewBegin: (state, action) => {
      state.liLoading = true;
    },

    linkdinOverviewSuccess: (state, action) => {
      state.linkdinOverviewData = action.payload;
      state.liLoading = false;
    },

    linkdinOverviewErr: (state, action) => {
      state.error = action.payload;
      state.liLoading = false;
    },

    twitterOverviewBegin: (state, action) => {
      state.twLoading = true;
    },

    twitterOverviewSuccess: (state, action) => {
      state.twitterOverviewData = action.payload;
      state.twLoading = false;
    },

    twitterOverviewErr: (state, action) => {
      state.error = action.payload;
      state.twLoading = false;
    },

    forcastOverviewBegin: (state, action) => {
      state.foLoading = true;
    },

    forcastOverviewSuccess: (state, action) => {
      state.forcastData = action.payload;
      state.foLoading = false;
    },

    forcastOverviewErr: (state, action) => {
      state.error = action.payload;
      state.foLoading = false;
    },

    socialTrafficBegin: (state, action) => {
      state.soLoading = true;
    },

    socialTrafficSuccess: (state, action) => {
      state.socialTrafficData = action.payload;
      state.soLoading = false;
    },

    socialTrafficErr: (state, action) => {
      state.error = action.payload;
      state.soLoading = false;
    },

    youtubeSubscribeBegin: (state, action) => {
      state.yuLoading = true;
    },

    youtubeSubscribeSuccess: (state, action) => {
      state.youtubeSubscribeData = action.payload;
      state.yuLoading = false;
    },

    youtubeSubscribeErr: (state, action) => {
      state.error = action.payload;
      state.yuLoading = false;
    },

    closeDealBegin: (state, action) => {
      state.cdLoading = true;
    },

    closeDealSuccess: (state, action) => {
      state.closeDealData = action.payload;
      state.cdLoading = false;
    },

    closeDealErr: (state, action) => {
      state.error = action.payload;
      state.cdLoading = false;
    },

    recentDealBegin: (state, action) => {
      state.recLoading = true;
    },

    recentDealSuccess: (state, action) => {
      state.recentDealData = action.payload;
      state.recLoading = false;
    },

    recentDealErr: (state, action) => {
      state.error = action.payload;
      state.recLoading = false;
    },
  },
});

export const {
  forcastOverviewBegin,
  forcastOverviewSuccess,
  forcastOverviewErr,

  twitterOverviewBegin,
  twitterOverviewSuccess,
  twitterOverviewErr,

  linkdinOverviewBegin,
  linkdinOverviewSuccess,
  linkdinOverviewErr,

  instagramOverviewBegin,
  instagramOverviewSuccess,
  instagramOverviewErr,

  youtubeSubscribeBegin,
  youtubeSubscribeSuccess,
  youtubeSubscribeErr,

  closeDealBegin,
  closeDealSuccess,
  closeDealErr,

  recentDealBegin,
  recentDealSuccess,
  recentDealErr,

  socialTrafficBegin,
  socialTrafficSuccess,
  socialTrafficErr,

  cashFlowBegin,
  cashFlowSuccess,
  cashFlowErr,

  incomeBegin,
  incomeSuccess,
  incomeErr,

  performanceBegin,
  performanceSuccess,
  performanceErr,

  updateLoadingBegin,
  updateLoadingSuccess,
  updateLoadingErr,

  trafficChanelBegin,
  trafficChanelSuccess,
  trafficChanelErr,

  deviceBegin,
  deviceSuccess,
  deviceErr,

  landingPageBegin,
  landingPageSuccess,
  landingPageErr,

  regionBegin,
  regionSuccess,
  regionErr,

  generatedBegin,
  generatedSuccess,
  generatedErr,

  topSaleBegin,
  topSaleSuccess,
  topSaleErr,

  locationBegin,
  locationSuccess,
  locationErr,
} = chartSlice.actions;

const forcastOverviewGetData = () => {
  return async (dispatch) => {
    const { today } = forcastOverview;
    try {
      dispatch(forcastOverviewBegin());
      dispatch(forcastOverviewSuccess(today));
    } catch (err) {
      dispatch(forcastOverviewErr(err));
    }
  };
};

const forcastOverviewFilterData = (value) => {
  return async (dispatch) => {
    try {
      dispatch(forcastOverviewBegin());
      setTimeout(() => {
        dispatch(forcastOverviewSuccess(forcastOverview[value]));
      }, 100);
    } catch (err) {
      dispatch(forcastOverviewErr(err));
    }
  };
};

const youtubeSubscribeGetData = () => {
  return async (dispatch) => {
    const { year } = youtubeSubscribe;
    try {
      dispatch(youtubeSubscribeBegin());
      dispatch(youtubeSubscribeSuccess(year));
    } catch (err) {
      dispatch(youtubeSubscribeErr(err));
    }
  };
};

const youtubeSubscribeFilterData = (value) => {
  return async (dispatch) => {
    try {
      dispatch(youtubeSubscribeBegin());
      setTimeout(() => {
        dispatch(youtubeSubscribeSuccess(youtubeSubscribe[value]));
      }, 100);
    } catch (err) {
      dispatch(youtubeSubscribeErr(err));
    }
  };
};

const closeDealGetData = () => {
  return async (dispatch) => {
    const { year } = closedDeals;
    try {
      dispatch(closeDealBegin());
      dispatch(closeDealSuccess(year));
    } catch (err) {
      dispatch(closeDealErr(err));
    }
  };
};

const closeDealFilterData = (value) => {
  return async (dispatch) => {
    try {
      dispatch(closeDealBegin());
      setTimeout(() => {
        dispatch(closeDealSuccess(closedDeals[value]));
      }, 100);
    } catch (err) {
      dispatch(closeDealErr(err));
    }
  };
};

const recentDealGetData = () => {
  return async (dispatch) => {
    const { year } = recentDeal;
    try {
      dispatch(recentDealBegin());
      dispatch(recentDealSuccess(year));
    } catch (err) {
      dispatch(recentDealErr(err));
    }
  };
};

const recentDealFilterData = (value) => {
  return async (dispatch) => {
    try {
      dispatch(recentDealBegin());
      setTimeout(() => {
        dispatch(recentDealSuccess(recentDeal[value]));
      }, 100);
    } catch (err) {
      dispatch(recentDealErr(err));
    }
  };
};

const socialTrafficGetData = () => {
  return async (dispatch) => {
    const { today } = SocialTrafficMetrics;
    try {
      dispatch(socialTrafficBegin());
      dispatch(socialTrafficSuccess(today));
    } catch (err) {
      dispatch(socialTrafficErr(err));
    }
  };
};

const socialTrafficFilterData = (value) => {
  return async (dispatch) => {
    try {
      dispatch(socialTrafficBegin());
      setTimeout(() => {
        dispatch(socialTrafficSuccess(SocialTrafficMetrics[value]));
      }, 100);
    } catch (err) {
      dispatch(socialTrafficErr(err));
    }
  };
};

const twitterOverviewGetData = () => {
  return async (dispatch) => {
    const { month } = twitterOverview;
    try {
      dispatch(twitterOverviewBegin());
      dispatch(twitterOverviewSuccess(month));
    } catch (err) {
      dispatch(twitterOverviewErr(err));
    }
  };
};

const twitterOverviewFilterData = (value) => {
  return async (dispatch) => {
    try {
      dispatch(twitterOverviewBegin());
      setTimeout(() => {
        dispatch(twitterOverviewSuccess(twitterOverview[value]));
      }, 100);
    } catch (err) {
      dispatch(twitterOverviewErr(err));
    }
  };
};

const instagramOverviewGetData = () => {
  return async (dispatch) => {
    const { month } = instagramOverview;
    try {
      dispatch(instagramOverviewBegin());
      dispatch(instagramOverviewSuccess(month));
    } catch (err) {
      dispatch(instagramOverviewErr(err));
    }
  };
};

const instagramOverviewFilterData = (value) => {
  return async (dispatch) => {
    try {
      dispatch(instagramOverviewBegin());
      setTimeout(() => {
        dispatch(instagramOverviewSuccess(instagramOverview[value]));
      }, 100);
    } catch (err) {
      dispatch(instagramOverviewErr(err));
    }
  };
};

const linkdinOverviewGetData = () => {
  return async (dispatch) => {
    const { month } = linkdinOverview;
    try {
      dispatch(linkdinOverviewBegin());
      dispatch(linkdinOverviewSuccess(month));
    } catch (err) {
      dispatch(linkdinOverviewErr(err));
    }
  };
};

const linkdinOverviewFilterData = (value) => {
  return async (dispatch) => {
    try {
      dispatch(linkdinOverviewBegin());
      setTimeout(() => {
        dispatch(linkdinOverviewSuccess(linkdinOverview[value]));
      }, 100);
    } catch (err) {
      dispatch(linkdinOverviewErr(err));
    }
  };
};

const cashFlowGetData = () => {
  return async (dispatch) => {
    const { year } = cashFlow;
    try {
      dispatch(cashFlowBegin());
      dispatch(cashFlowSuccess(year));
    } catch (err) {
      dispatch(cashFlowErr(err));
    }
  };
};

const cashFlowFilterData = (value) => {
  return async (dispatch) => {
    try {
      dispatch(cashFlowBegin());
      setTimeout(() => {
        dispatch(cashFlowSuccess(cashFlow[value]));
      }, 100);
    } catch (err) {
      dispatch(cashFlowErr(err));
    }
  };
};

const incomeGetData = () => {
  return async (dispatch) => {
    const { year } = income;
    try {
      dispatch(incomeBegin());
      dispatch(incomeSuccess(year));
    } catch (err) {
      dispatch(incomeErr(err));
    }
  };
};

const incomeFilterData = (value) => {
  return async (dispatch) => {
    try {
      dispatch(incomeBegin());
      setTimeout(() => {
        dispatch(incomeSuccess(income[value]));
      }, 100);
    } catch (err) {
      dispatch(incomeErr(err));
    }
  };
};

const performanceGetData = () => {
  return async (dispatch) => {
    const { year } = performance;
    try {
      dispatch(performanceBegin());
      dispatch(performanceSuccess(year));
    } catch (err) {
      dispatch(performanceErr(err));
    }
  };
};

const performanceFilterData = (value) => {
  return async (dispatch) => {
    try {
      dispatch(performanceBegin());
      setTimeout(() => {
        dispatch(performanceSuccess(performance[value]));
      }, 100);
    } catch (err) {
      dispatch(performanceErr(err));
    }
  };
};

const trafficChanelGetData = () => {
  return async (dispatch) => {
    const { year } = trafficChanel;
    try {
      dispatch(trafficChanelBegin());
      dispatch(trafficChanelSuccess(year));
    } catch (err) {
      dispatch(trafficChanelErr(err));
    }
  };
};

const trafficChanelFilterData = (value) => {
  return async (dispatch) => {
    try {
      dispatch(trafficChanelBegin());
      setTimeout(() => {
        dispatch(trafficChanelSuccess(trafficChanel[value]));
      }, 100);
    } catch (err) {
      dispatch(trafficChanelErr(err));
    }
  };
};

const deviceGetData = () => {
  return async (dispatch) => {
    const { year } = device;
    try {
      dispatch(deviceBegin());
      dispatch(deviceSuccess(year));
    } catch (err) {
      dispatch(deviceErr(err));
    }
  };
};

const deviceFilterData = (value) => {
  return async (dispatch) => {
    try {
      dispatch(deviceBegin());
      setTimeout(() => {
        dispatch(deviceSuccess(device[value]));
      }, 100);
    } catch (err) {
      dispatch(deviceErr(err));
    }
  };
};

const setIsLoading = () => {
  return async (dispatch) => {
    try {
      dispatch(updateLoadingBegin());
      setTimeout(() => {
        dispatch(updateLoadingSuccess());
      }, 100);
    } catch (err) {
      dispatch(updateLoadingErr(err));
    }
  };
};

const landingPageGetData = () => {
  return async (dispatch) => {
    const { year } = trafficChanel;
    try {
      dispatch(landingPageBegin());
      dispatch(landingPageSuccess(year));
    } catch (err) {
      dispatch(landingPageErr(err));
    }
  };
};

const landingPageFilterData = (value) => {
  return async (dispatch) => {
    try {
      dispatch(landingPageBegin());
      setTimeout(() => {
        dispatch(landingPageSuccess(trafficChanel[value]));
      }, 100);
    } catch (err) {
      dispatch(landingPageErr(err));
    }
  };
};

const regionGetData = () => {
  return async (dispatch) => {
    const { year } = region;
    try {
      dispatch(regionBegin());
      dispatch(regionSuccess(year));
    } catch (err) {
      dispatch(regionErr(err));
    }
  };
};

const regionFilterData = (value) => {
  return async (dispatch) => {
    try {
      dispatch(regionBegin());
      setTimeout(() => {
        dispatch(regionSuccess(region[value]));
      }, 100);
    } catch (err) {
      dispatch(regionErr(err));
    }
  };
};

const generatedGetData = () => {
  return async (dispatch) => {
    const { year } = generated;
    try {
      dispatch(generatedBegin());
      dispatch(generatedSuccess(year));
    } catch (err) {
      dispatch(generatedErr(err));
    }
  };
};

const generatedFilterData = (value) => {
  return async (dispatch) => {
    try {
      dispatch(generatedBegin());
      setTimeout(() => {
        dispatch(generatedSuccess(generated[value]));
      }, 100);
    } catch (err) {
      dispatch(generatedErr(err));
    }
  };
};

const topSaleGetData = () => {
  return async (dispatch) => {
    const { year } = topSale;
    try {
      dispatch(topSaleBegin());
      dispatch(topSaleSuccess(year));
    } catch (err) {
      dispatch(topSaleErr(err));
    }
  };
};

const topSaleFilterData = (value) => {
  return async (dispatch) => {
    try {
      dispatch(topSaleBegin());
      setTimeout(() => {
        dispatch(topSaleSuccess(topSale[value]));
      }, 100);
    } catch (err) {
      dispatch(topSaleErr(err));
    }
  };
};

const locationGetData = () => {
  return async (dispatch) => {
    const { today } = location;
    try {
      dispatch(locationBegin());
      dispatch(locationSuccess(today));
    } catch (err) {
      dispatch(locationErr(err));
    }
  };
};

const locationFilterData = (value) => {
  return async (dispatch) => {
    try {
      dispatch(locationBegin());
      setTimeout(() => {
        dispatch(locationSuccess(location[value]));
      }, 100);
    } catch (err) {
      dispatch(locationErr(err));
    }
  };
};

export {
  locationGetData,
  locationFilterData,
  topSaleGetData,
  topSaleFilterData,
  generatedFilterData,
  generatedGetData,
  regionGetData,
  regionFilterData,
  landingPageFilterData,
  landingPageGetData,
  deviceFilterData,
  deviceGetData,
  trafficChanelGetData,
  trafficChanelFilterData,
  setIsLoading,
  performanceFilterData,
  performanceGetData,
  incomeGetData,
  incomeFilterData,
  forcastOverviewGetData,
  forcastOverviewFilterData,
  twitterOverviewGetData,
  twitterOverviewFilterData,
  youtubeSubscribeFilterData,
  youtubeSubscribeGetData,
  socialTrafficFilterData,
  socialTrafficGetData,
  instagramOverviewGetData,
  instagramOverviewFilterData,
  linkdinOverviewGetData,
  linkdinOverviewFilterData,
  cashFlowGetData,
  cashFlowFilterData,
  closeDealGetData,
  closeDealFilterData,
  recentDealGetData,
  recentDealFilterData,
};

export default chartSlice.reducer;
